import { Loader as LoaderIcon } from 'lucide-react'

export const Loader = () => {
	return (
		<span className=''>
			<LoaderIcon className='animate-spin' />
		</span>
	)
}
